
import Quill from "quill";

export default {
    props: {
        value: String,
        placeholder: String,
        readonly: Boolean,
        formats: Array,
        editorStyle: null
    },
    quill: null,
    watch: {
        value(newValue, oldValue) {
          if (newValue !== oldValue && this.quill && !this.quill.hasFocus()) {
            this.renderValue(newValue);
          }
        }
    },
    mounted() {
        this.quill = new Quill(this.$refs.editorElement, {
            modules: {
                toolbar: this.$refs.toolbarElement
            },
            readOnly: this.readonly,
            theme: 'snow',
            formats: this.formats,
            placeholder: this.placeholder
        });

        this.renderValue(this.value);

        this.quill.on('text-change', (delta, oldContents, source) => {
            if (source === 'user') {
                let html = this.$refs.editorElement.children[0].innerHTML;
                let text = this.quill.getText().trim();
                if (html === '<p><br></p>') {
                    html = '';
                }

                this.$emit('input', html);
                this.$emit('text-change', {
                    htmlValue: html,
                    textValue: text,
                    delta: delta,
                    source: source
                });
            }
        });
    },
    methods: {
        renderValue(value) {
            if (this.quill) {
                if (value)
                    this.quill.pasteHTML(value);
                else
                    this.quill.setText('');
            }
        }
    },
    beforeDestroy() {
        this.quill = null;
    }
}
